const FromArrEditor = [{
		key: 'LEVEL3',
		title: "L3：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: true,
		marginLeft: 80,
		marginTop: 0,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		key: 'LEVEL4',
		title: "L4：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: true,
		marginLeft: 80,
		marginTop: 0,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		key: 'CostTypeName',
		title: "价格类型：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: true,
		marginLeft: 40,
		marginTop: 24,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		key: 'CostValue',
		title: "价格：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 70,
		marginTop: 18,
		displayVal: "inline-block",
		fontWeightVal: 500
	}
];
export default FromArrEditor;